import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectAdmin } from '../selectors/admin.selector';
import { adminActions } from '../actions/admin.actions';
import { AdminValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class AdminFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly admin$ = this.store.select(selectAdmin);
    readonly adminNonNullable$ = this.store.select(selectAdmin).pipe(filter((admin) => admin !== null));

    readonly admin = this.store.selectSignal(selectAdmin);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getAdmin(id: string): void {
        this.store.dispatch(adminActions.getAdmin({ id }));
    }

    createAdmin(value: AdminValue): void {
        this.store.dispatch(adminActions.createAdmin({ value }));
    }

    updateAdmin(id: string, value: AdminValue): void {
        this.store.dispatch(adminActions.updateAdmin({ id, value }));
    }

    deleteAdmin(id: string): void {
        this.store.dispatch(adminActions.deleteAdmin({ id }));
    }

    clear(): void {
        this.store.dispatch(adminActions.clear());
    }
}
